module.exports = __webpack_public_path__ + "img/stamp-vegetable.6581c653.png";